import { ReactNode, useContext } from "react";
import cn from "classnames";

import { Dropdown as CommonDropdown, DropdownFieldProps } from "capitalrx-components-2.0/lib/forms";

import { ThemeSelectorContext } from "@/basic/context";

import styles from "../styles.module.scss";

export interface DropdownOptionProps {
  children: ReactNode;
  value: string | null;
}

export const Dropdown = (props: DropdownFieldProps) => {
  const { children } = props;
  const { client } = useContext(ThemeSelectorContext);

  const dropdownClass = cn({ [styles["DropdownWrapper"]]: !!client });

  return (
    <CommonDropdown.Field {...props} className={dropdownClass}>
      {children}
    </CommonDropdown.Field>
  );
};
